import React from "react";
import {
  Combobox,
  makeStyles,
  Option,
  tokens,
} from "@fluentui/react-components";
import { LocationParams } from "../../../types/drayage";
import useMapboxSearch from "./useMapboxSearch";

const useStyles = makeStyles({
  combobox: {
    width: "100%",
    minWidth: "0",
  },
});

export interface MapboxSearchFieldProps {
  placeholder?: string;
  onSelected: (location: LocationParams) => void;
}

export const MapboxSearchField: React.FC<MapboxSearchFieldProps> = ({
  placeholder = "Search location",
  onSelected,
}) => {
  const styles = useStyles();

  const {
    searchValue,
    suggestions,
    handleSearch,
    handleSuggestionSelect,
    formatSuggestion,
  } = useMapboxSearch({
    onLocationSelect: (location) => {
      onSelected(location);
    },
  });

  const handleChange = (newValue: string) => {
    handleSearch(newValue);
  };

  return (
    <Combobox
      freeform
      className={styles.combobox}
      value={searchValue}
      placeholder={placeholder}
      onChange={(ev) => handleChange(ev.currentTarget.value)}
    >
      {suggestions.map((suggestion) => {
        const { primary, secondary } = formatSuggestion(suggestion);

        return (
          <Option
            key={suggestion.mapbox_id}
            value={primary}
            text={secondary}
            onClick={() => handleSuggestionSelect(suggestion)}
          >
            <div>{primary}</div>
            <div
              style={{
                fontSize: "12px",
                color: tokens.colorNeutralForeground2,
              }}
            >
              {secondary}
            </div>
          </Option>
        );
      })}
    </Combobox>
  );
};

export default MapboxSearchField;
